export const EN_TRANSLATION = {
  lang: 'en',
  messages: {
  }
};
